webpackJsonp([162898551421021],{

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamorous = __webpack_require__(5);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _components = __webpack_require__(12);
	
	var _style = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Title = _glamorous2.default.h1.withConfig({
	  displayName: '404__Title'
	})(_extends({}, _style.typography.largeTitle, _style.margin.bottom(2)));
	
	var Body = _glamorous2.default.p.withConfig({
	  displayName: '404__Body'
	})(_extends({}, _style.typography.body));
	
	var FourOhFour = function FourOhFour() {
	  return _react2.default.createElement(
	    _components.Wrapper,
	    { py: 6, css: { textAlign: 'center' } },
	    _react2.default.createElement(
	      Title,
	      null,
	      'Oh no! This page doesn\u2019t exist.'
	    ),
	    _react2.default.createElement(
	      Body,
	      null,
	      'Never fear. There\u2019s much more to explore starting on my',
	      ' ',
	      _react2.default.createElement(
	        _components.InlineLink,
	        { href: '/' },
	        'homepage'
	      ),
	      '.'
	    )
	  );
	};
	
	exports.default = FourOhFour;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-8946b16a3088effd87e9.js